import ReportProperty from '@/Enums/Report/BeeswaxReportProperties.enum';
import ReportView from '@/Enums/ReportingDashboard/ReportView/ReportView.enum';
import type { ITotalReportRecord } from '@/Interfaces/ReportingDashboard/Search/ReportRecord.interface';
import type { IState } from '@/Interfaces/Slices/ReportingDashboard/Search/State.interface';
import type { SearchReportView } from '@/types/ReportingDashboard/Search.type';
import { DEFAULT_LOADING_REQUEST_ID } from '../slice';

export const defaultTotals: ITotalReportRecord = {
  [ReportProperty.IMPRESSIONS]: 0,
  [ReportProperty.COST_PER_CLICK]: 0,
  [ReportProperty.COST_PER_IMPRESSION]: 0,
  [ReportProperty.COST_PER_CONVERSION]: 0,
  [ReportProperty.SPEND]: 0,
  [ReportProperty.CTR]: 0,
};

export const initialState: IState = {
  //#region report data
  totals: defaultTotals,

  //#region grid
  dateReport: [],
  platformReport: [],
  advertiserReport: [],
  campaignReport: [],
  adGroupReport: [],
  keywordReport: [],
  //#endregion

  //#endregion

  //#region filters
  campaigns: [],
  //#endregion

  //#region requestIds
  totalsRequestId: DEFAULT_LOADING_REQUEST_ID,

  //#region grid
  dateReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  platformReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  advertiserReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  campaignReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  adGroupReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  keywordReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  //#endregion
  //#endregion

  errorCardMessage: '',
};

export const allowedSearchTablesToPrint: SearchReportView[] = [
  ReportView.Date,
  ReportView.Platform,
  ReportView.Advertiser,
  ReportView.Campaign,
  ReportView.AdGroup,
  ReportView.Keyword,
];

export const searchImpressionTypes = [
  ReportView.Date,
  ReportView.Platform,
  ReportView.Advertiser,
  ReportView.Campaign,
  ReportView.AdGroup,
  ReportView.Keyword,
].map(view => ({ label: view, value: view }));
